/* global $:false */

import htmx from 'htmx.org/dist/htmx.js'

export default class RailsHtmx {
  static start() {
    htmx.on('htmx:beforeRequest', (e) => {
      const token = $('meta[name="csrf-token"]').attr('content')
      e.detail.xhr.setRequestHeader('X-CSRF-Token', token)
    })
  }
}
